import { Provider } from "react-redux"
import { ChakraProvider } from "@chakra-ui/react"
import createStore from "@app/createStore"
import { RouterProvider } from "react-router-dom"
import { appRouter } from "@router/appRouter"

function App() {

  return (
    <ChakraProvider>
      <Provider store={createStore}>
        <RouterProvider router={appRouter}/>
      </Provider>
    </ChakraProvider>
  )
}

export default App
